import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { authApi } from '@/api/authApi'
import { useAuthStore } from '@/store/authStore'
import apiClient from '@/api/client'
import type { User } from '@/types'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'

export const LoginPage: React.FC = () => {
  const navigate = useNavigate()
  const { setUser, setCurrentAssistant } = useAuthStore()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const tokens = await authApi.login(email, password)
      localStorage.setItem('access_token', tokens.access_token)
      localStorage.setItem('refresh_token', tokens.refresh_token)

      const { data: user } = await apiClient.get<User>('/users/me')
      setCurrentAssistant(null)
      setUser(user)

      navigate('/')
    } catch (err: any) {
      setError(err?.error || err?.message || 'Ошибка входа. Проверьте email и пароль.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: 'var(--bg-secondary)' }}
    >
      <div
        className="w-full max-w-[400px] rounded-2xl p-8"
        style={{
          backgroundColor: 'var(--bg-primary)',
          boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
        }}
      >
        {/* Logo */}
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <img src="/logo.png" alt="ProCoach" className="w-10 h-10 rounded-xl" />
          <span className="text-[22px] font-bold" style={{ color: 'var(--text-primary)' }}>
            ProCoach
          </span>
        </div>

        <h2 className="text-[18px] font-semibold text-center mb-6" style={{ color: 'var(--text-primary)' }}>
          Вход в аккаунт
        </h2>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="coach@example.com"
            required
            autoFocus
          />
          <Input
            label="Пароль"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />

          {error && (
            <div
              className="text-[13px] px-3 py-2 rounded-lg"
              style={{ backgroundColor: 'var(--danger-light)', color: 'var(--danger)' }}
            >
              {error}
            </div>
          )}

          <Button type="submit" loading={loading} className="w-full mt-2">
            Войти
          </Button>
        </form>

        <p className="text-center text-[14px] mt-6" style={{ color: 'var(--text-secondary)' }}>
          Нет аккаунта?{' '}
          <Link
            to="/register"
            className="font-medium hover:underline"
            style={{ color: 'var(--accent)' }}
          >
            Зарегистрироваться
          </Link>
        </p>
      </div>
    </div>
  )
}
